// components/ai/ahamoment/TipBox.jsx
import React from 'react';
import { FaLightbulb } from 'react-icons/fa';

const TipBox = ({ children }) => {
  return (
    <div style={{
      backgroundColor: '#2C2F36',
      color: '#FFFFFF',
      borderRadius: '16px',
      padding: '1rem',
      marginBottom: '1rem',
      fontFamily: 'Nunito Sans',
      boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
    }}>
      <div style={{
        fontWeight: '700',
        marginBottom: '0.75rem',
        fontSize: '17px',
        color: '#FFB800',
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
      }}>
        <FaLightbulb /> Tip
      </div>
      <div style={{ fontSize: '16px', lineHeight: '1.6' }}>{children}</div>
    </div>
  );
};

export default TipBox;
